import React from 'react';
import { Select, Box, TextFieldSize, TextFieldAppearance, Text, FormControl } from '@bechtel/gds';
import { useField } from 'formik';
import { t, Trans } from '@lingui/macro';
import { TimesheetReason } from '@bechtel/types';
import { useLingui } from '@lingui/react';
import { ErrorRetry } from '@bechtel/client-common';
import { NetworkStatus } from '@apollo/client';
import { get } from 'lodash';
import { useTimeSheetReason } from '~/hooks';
import { CommentMessages } from '~/components/atoms';
export const DropdownItem = ({ item }: { item: any }) => {
  return (
    <Text size="400" color="grey.1000">
      <Trans id={CommentMessages[item.name].message} />
    </Text>
  );
};
export const DropdownSelectedItem = ({ item }: { item: any }) => {
  return (
    <Text family="graphik" size="400" color="grey.1000">
      <Trans id={CommentMessages[item.name].message} />
    </Text>
  );
};
export interface TimesheetReasonProps {
  index?: string;
  name: string;
  placeholder: string;
  isDisabled?: boolean;
}
export const TimeSheetReason: React.FC<TimesheetReasonProps> = ({ index, name, placeholder, isDisabled }) => {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;
  const { loading, error, data, refetch, networkStatus } = useTimeSheetReason(true);
  const { i18n } = useLingui();
  const reasonList: TimesheetReason[] = get(data, 'timesheetReasons', []);
  return (
    <Box flexDirection={{ sm: 'column' }} m={{ sm: '500' }} key={index}>
      {!loading && error && (
        <ErrorRetry refetch={refetch}>
          <Trans>There was a problem loading timesheet reason. Please retry. </Trans>
        </ErrorRetry>
      )}
      <FormControl label={t`Reason (Optional)`}>
        <Select
          key={index}
          disabled={isDisabled}
          {...field}
          placeholder={placeholder}
          size={TextFieldSize.LARGE}
          appearance={TextFieldAppearance.NORMAL}
          items={reasonList}
          itemComponent={DropdownItem}
          selectedItem={field?.value ? field?.value : ''}
          selectedComponent={DropdownSelectedItem}
          onSelectedItemChange={async (changes) => {
            setValue(changes.selectedItem);
          }}
          loading={loading || networkStatus === NetworkStatus.refetch}
        />
        {meta.touched && meta.error ? (
          <Box pt={{ sm: '200' }}>
            <Text color="bechtel.red">{i18n._(meta.error)}</Text>
          </Box>
        ) : null}
      </FormControl>
    </Box>
  );
};
